import { useSearchParams } from "react-router-dom";

export const useURLParamsAssignments = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const get = (name: string) => {
    return searchParams.get(name) ?? "";
  };
  const set = (name: string, value: any) => {
    searchParams.set(name, value);
    setSearchParams(searchParams.toString());
  };
  const rm = (name) => {
    searchParams.delete(name);
    setSearchParams(searchParams.toString());
  };

  return {
    page: {
      get: () => {
        const pg = parseInt(get("page"));
        if (isNaN(pg) || pg < 1) return 1;
        return pg;
      },
      set: (page: string) => set("page", page),
      rm: () => rm("page"),
    },
  };
};
